import React from "react";

export const Toolbar = () => {
  return (
    <div className="toolbar">
      <i className="fas fa-pen"></i>
      <i className="fas fa-heart"></i>
      <i className="fas fa-share"></i>
    </div>
  );
};
